import { supabase } from '@/lib/supabase';

export interface FundEmailItem {
  label: string;
  value: string;
}

export interface FundEmailParams {
  userId: string;
  type: 'deposit' | 'withdraw';
  title: string;
  amount: string;
  items: FundEmailItem[];
  time: string;
}

/**
 * 出入金申请通知邮件（异步发送，不阻塞提交流程）
 */
export async function notifyFundEmail(params: FundEmailParams): Promise<void> {
  try {
    // 拉取用户姓名/手机号，方便后台识别是谁的申请
    let userLabel = '';
    try {
      const { data: profile } = await supabase
        .from('profiles')
        .select('name, phone')
        .eq('id', params.userId)
        .maybeSingle();
      const name = profile?.name || '';
      const phone = profile?.phone || '';
      userLabel = [name, phone].filter(Boolean).join(' · ');
    } catch {
      // 姓名拉取失败不阻断邮件发送
    }

    await supabase.functions.invoke('send-fund-email', {
      body: {
        type: params.type,
        title: params.title,
        amount: params.amount,
        user: userLabel,
        items: params.items,
        time: params.time,
      },
    });
  } catch (err) {
    console.error('[fund-email] failed:', err);
  }
}